import React from "react";
import { Helmet } from "react-helmet";
import { LoginForm } from "./loginForm";
import { getPageTitle } from "../../helpers/envTitle";

import login from "../../assets/images/login.jpg";

import "./style.css";

export const LoginPage = () => {
  return (
    <div className={"login__page__wrapper"}>
      <Helmet>
        <title>{getPageTitle()}</title>
      </Helmet>
      <img src={login} alt={"login"} />
      <LoginForm />
    </div>
  );
};
